import { Type } from "@scalar/typebox";
const xScalarClientConfigEnvVarSchema = Type.Union([
  Type.Partial(
    Type.Object({
      description: Type.String(),
      default: Type.String()
    })
  ),
  Type.String()
]);
const xScalarClientConfigEnvironmentSchema = Type.Object({
  description: Type.Optional(Type.String()),
  color: Type.Optional(Type.String()),
  /** A map of variables by name */
  variables: Type.Record(Type.String(), xScalarClientConfigEnvVarSchema)
});
const xScalarClientConfigEnvironmentsSchema = Type.Record(Type.String(), xScalarClientConfigEnvironmentSchema);
export {
  xScalarClientConfigEnvVarSchema,
  xScalarClientConfigEnvironmentSchema,
  xScalarClientConfigEnvironmentsSchema
};
//# sourceMappingURL=x-scalar-client-config-environments.js.map
